import request from '@/utils/request_2'

/** 一体化健康管理工作台接口，统一走 /system 网关前缀 */
const prefix = '/system'

/** 慢病会员列表：姓名/手机号搜索，返回评分和风险徽标 */
export function listWorkbenchMembers(query) {
  return request({
    url: prefix + '/healthWorkbench/memberList',
    method: 'get',
    params: query
  })
}

/** 会员全景档案：顶部统计、四模块摘要、流程完整度，进入详情先调这个 */
export function getWorkbenchProfile(memberId) {
  return request({
    url: prefix + '/healthWorkbench/profile/' + memberId,
    method: 'get'
  })
}

/** 生成或重新生成健康报告，大模型耗时较长，超时单独放到 60 秒 */
export function generateHealthReport(memberId) {
  return request({
    url: prefix + '/health-assessment-report/generate/' + memberId,
    method: 'post',
    timeout: 60000
  })
}

/** 查询最新报告；无报告时 data 为 null */
export function getWorkbenchReport(memberId) {
  return request({
    url: prefix + '/health-assessment-report/workbench/' + memberId,
    method: 'get'
  })
}

/**
 * 慢病标签字典
 * data: [{ id, labelName, isChronicDisease, isShow, createTime }]
 */
export function listMemberLabels(params) {
  return request({
    url: prefix + '/memberLabel/list',
    method: 'get',
    params
  })
}

/** 给会员添加标签，body: { memberId, labelId } */
export function addMemberLabelRelation(data) {
  return request({
    url: prefix + '/memberLabelRecommend/relation/add',
    method: 'post',
    data
  })
}

/** 删除会员标签 */
export function removeMemberLabelRelation(memberId, labelId) {
  return request({
    url: prefix + '/memberLabelRecommend/relation/' + memberId + '/' + labelId,
    method: 'delete'
  })
}

/** 标签模块：已生效标签 + 待确认推荐 */
export function getLabelWorkbench(memberId) {
  return request({
    url: prefix + '/memberLabelRecommend/workbench/' + memberId,
    method: 'get'
  })
}

/** 触发智能推荐，返回本次新增条数，成功后需刷新标签 */
export function generateLabelRecommend(memberId) {
  return request({
    url: prefix + '/memberLabelRecommend/generate/' + memberId,
    method: 'post'
  })
}

/** 采纳推荐，id 为推荐记录 id，采纳后写入会员标签 */
export function adoptLabelRecommend(id) {
  return request({
    url: prefix + '/memberLabelRecommend/adopt/' + id,
    method: 'post'
  })
}

/** 忽略推荐，忽略后不再出现在待确认列表 */
export function ignoreLabelRecommend(id) {
  return request({
    url: prefix + '/memberLabelRecommend/ignore/' + id,
    method: 'post'
  })
}

/** 用药台账列表，与药盒设备无关 */
export function listMemberMedication(memberId) {
  return request({
    url: prefix + '/memberMedication/list',
    method: 'get',
    params: { memberId }
  })
}

/** 新增或编辑用药台账；有 id 为编辑 */
export function saveMemberMedication(data) {
  return request({
    url: prefix + '/memberMedication/add',
    method: 'post',
    data
  })
}

/** 停药，已停药再次调用会提示已停药 */
export function stopMemberMedication(id) {
  return request({
    url: prefix + '/memberMedication/stop/' + id,
    method: 'post'
  })
}

/** 该会员可发放的已发布方案模板 */
export function listAvailableSchemeTemplates(memberId) {
  return request({
    url: prefix + '/healthSchemeTemplate/available',
    method: 'get',
    params: { memberId }
  })
}

/** 模板详情，含任务项，发放前勾选任务用 */
export function getSchemeTemplateDetail(id) {
  return request({
    url: prefix + '/healthSchemeTemplate/detail/' + id,
    method: 'get'
  })
}

/** 发放方案，itemIds 为空表示模板全部启用任务项，返回新实例 id */
export function issueHealthScheme(data) {
  return request({
    url: prefix + '/memberHealthSchemeInstance/issue',
    method: 'post',
    data
  })
}

/** 终止方案，状态改为已终止 */
export function terminateHealthScheme(id) {
  return request({
    url: prefix + '/memberHealthSchemeInstance/terminate/' + id,
    method: 'post'
  })
}

/** 会员全部方案实例，执行中优先 */
export function listMemberSchemes(memberId) {
  return request({
    url: prefix + '/memberHealthSchemeInstance/listByMember/' + memberId,
    method: 'get'
  })
}

/** 方案进度：累计完成、今日完成、百分比 */
export function getSchemeProgress(id) {
  return request({
    url: prefix + '/memberHealthSchemeInstance/progress/' + id,
    method: 'get'
  })
}

/** 当天已展开的打卡任务 */
export function listTodaySchemeTasks(memberId) {
  return request({
    url: prefix + '/memberSchemeDayTask/today/' + memberId,
    method: 'get'
  })
}
